/* eslint-disable max-len */
import React, { ComponentProps } from "react";
import { Form } from "antd";
import { BaseFormTitle } from "components/common/forms/BaseFormTitle";
import { BaseFormItem } from "components/common/forms/BaseFormItem";
import { BaseFormList } from "components/common/forms/BaseFormList";

export type BaseFormProps = Omit<ComponentProps<typeof Form>, "onFinish"> & {
 onFinish?: (values: any) => void;
};

export interface BaseFormInterface<T> extends React.FC<T> {
  Title: typeof BaseFormTitle;
  Item: typeof BaseFormItem;
  List: typeof BaseFormList;
  useForm: typeof Form.useForm;
  Provider: typeof Form.Provider;
}

export const BaseForm: BaseFormInterface<BaseFormProps> = ({
  onFinishFailed,
  layout = "vertical",
  ...props
}) => {
  return <Form onFinishFailed={onFinishFailed} layout={layout} {...props} />;
};

BaseForm.Title = BaseFormTitle;
BaseForm.Item = BaseFormItem;
BaseForm.List = BaseFormList;
BaseForm.useForm = Form.useForm;
BaseForm.Provider = Form.Provider;
